import React from 'react';

const Week6Newsletter: React.FC = () => {
  return (
    <div className="newsletter-archive">
      <div className="newspaper-container">
        <div className="newspaper-header">
          <div className="newspaper-masthead">
            <h1 className="newspaper-title">AMBERWOOD FANTASY TIMES</h1>
            <div className="newspaper-subtitle">The Premier Source for Fantasy Football News & Analysis</div>
            <div className="newspaper-meta">
              <span className="edition">Week 6 Edition</span>
              <span className="date">October 2025</span>
              <span className="price">FREE</span>
            </div>
          </div>
        </div>

        <div className="newspaper-content">
          <div className="main-story">
            <h2 className="headline">Week 6: The Perfect Season Falls</h2>
            <div className="byline">By the Office of the Commissioner</div>

            <div className="center-image" style={{marginBottom: '30px', textAlign: 'center', width: '100%'}}>
              <div style={{border: '1px solid #ddd', padding: '20px', borderRadius: '8px', backgroundColor: '#f9f9f9', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', display: 'inline-block', maxWidth: '700px', width: '100%'}}>
                <img src="/IMG_3754.WEBP" alt="Week 6 Highlights" style={{width: '100%', maxWidth: '680px', height: 'auto', border: '2px solid #333', borderRadius: '4px'}} />
                <div className="draft-caption" style={{fontSize: '12px', fontStyle: 'italic', textAlign: 'center', marginTop: '10px'}}>
                  Has Roshik thrown away his season with his recent trades with Anudeep?
                </div>
              </div>
            </div>

            <div className="story-layout">
              <div className="story-column">
                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>📊 Week 6 Matchup Recap</h3>

                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>🔥 Game of the Week</h3>

                <div className="matchup-result">
                  <h4>"UPSET OF THE SEASON: Swahili Hands Pranav His First Loss!" swahili28 (145.64) def. pranavj20 (143.90)</h4>
                  <p><strong>Winner Analysis:</strong> In the game of the season, swahili28 delivered a knockout blow to the previously undefeated pranavj20, winning by just 1.74 points. This 145-point performance shows swahili28's championship ceiling when they get balanced production. Ja'Marr Chase and the supporting cast all delivered the biggest win of their season. Moving to 4-2, they've proven they can beat anyone.</p>
                  <p><strong>Loser Analysis:</strong> pranavj20's perfect season ends at 5-1 after their 143-point output fell just short. This wasn't a bad performance - they would've beaten every other team this week. Sometimes you just run into a buzzsaw. Still firmly in control of the league at 5-1, but the aura of invincibility is gone and Puka's injury will test the team's strong depth.</p>
                </div>

                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>💪 Statement Victories</h3>

                <div className="matchup-result">
                  <h4>"ARSB STRIKES BACK: Pranav P Crushes Abhiu" pranav4789 (161.49) def. abhiu (116.11)</h4>
                  <p><strong>Winner Analysis:</strong> pranav4789's 161-point explosion is exactly what they needed after last week's disaster. Devon Achane and the supporting cast returned to form, delivering their highest total since Week 2. Moving to 3-3 keeps playoff hopes strong without fully banking on the wild card spot. This is the type of must-win performance that can spark a hot streak in the stretch run.</p>
                  <p><strong>Loser Analysis:</strong> abhiu drops to 0-6 with their 116-point effort. The winless nightmare continues despite respectable production. At this point, they're playing spoiler and auditioning players for next season.</p>
                </div>

                <div className="matchup-result">
                  <h4>"CMC CARRIES: Ankithe Dominates Struggling Abhishek" ankithe (130.59) def. abhishekD (89.92)</h4>
                  <p><strong>Winner Analysis:</strong> CMC's reliable 24.10 points anchored a comfortable 130-point victory that moves ankithe to 3-3. After losing three straight, this win keeps their playoff hopes alive. The supporting cast around CMC finally showed up when it mattered most.</p>
                  <p><strong>Loser Analysis:</strong> abhishekD's catastrophic 89-point disaster is their worst performance of the season. With multiple single digit scores, a team-wide underperformance dropped them to 3-3. The only saving grace was Drake London's monstrous performance otherwise we could have been looking at an all time low score. The boom-bust pattern continues, but this bust came at the worst possible time.</p>
                </div>

                <div className="matchup-result">
                  <h4>"HOT STREAK CONTINUES: SahitReddi Rolls Past Taaha" SahitReddi (135.00) def. taahakm (113.99)</h4>
                  <p><strong>Winner Analysis:</strong> SahitReddi's third straight strong performance (170 → 146 → 135) has them rolling at 4-2. This team has completely figured things out and is now a legitimate championship threat. Bijan Robinson's consistency anchors a balanced attack firing on all cylinders.</p>
                  <p><strong>Loser Analysis:</strong> taahakm's 113 points represent regression from their hot start. At 3-3, the lucky early wins are wearing off, and their low scoring ceiling is being exposed. They're clinging to playoff hopes but need to find more consistent production.</p>
                </div>
              </div>

              <div className="story-column">
                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>⚔️ Competitive Battles</h3>

                <div className="matchup-result">
                  <h4>"SURVIVAL MODE: Audumula Pulls Away from Roshik" audumula (143.80) def. roshik (109.93)</h4>
                  <p><strong>Winner Analysis:</strong> audumula's fourth straight win (127 → 142 → 143) has them surging to 4-2. This team is on an absolute heater and has established themselves as a legit playoff contender. The 143-point output shows they've found sustainable scoring beyond just hot streaks.</p>
                  <p><strong>Loser Analysis:</strong> roshik's disappointing 109 points drops them to 2-4 and in danger of falling behind the pack. Saquon Barkley's regression is killing this team's chances. At 2-4, they need to win in a hurry to have any shot at playoffs.</p>
                </div>

                <div className="matchup-result">
                  <h4>"UPSET SPECIAL: Akhil Stuns Kulkdaddy" akhilmetukuru (116.08) def. kulkdaddy47 (99.08)</h4>
                  <p><strong>Winner Analysis:</strong> akhilmetukuru's 116 points isn't spectacular, but it was enough to upset kulkdaddy47 and move to 2-4. This win keeps faint playoff hopes alive and shows they can compete when opponents underperform.</p>
                  <p><strong>Loser Analysis:</strong> kulkdaddy47's shocking 99-point disaster is their worst output of the season. After back-to-back 150+ point explosions, this crash back to earth drops them to 3-3. The core pieces from the Jets all disappeared simultaneously in a nightmare performance.</p>
                </div>

                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>🍀 Mickey of the Week Award</h3>
                <div className="matchup-result">
                  <h4>"Winner": akhilmetukuru (Akhil) - The Low-Scoring Giant Slayer</h4>
                  <p>akhilmetukuru takes home this week's Mickey Award for pulling off the ultimate upset with the lowest winning score of the week. Beating kulkdaddy47 with just 116 points is the definition of catching your opponent at the perfect time.</p>
                  <p><strong>The Lucky Victory Breakdown:</strong></p>
                  <ul>
                    <li>Won with just 116.08 points</li>
                    <li>Faced kulkdaddy47's season-worst 99.08 points - caught them in total collapse</li>
                    <li>kulkdaddy47 came off back-to-back 150+ point explosions (173 → 151)</li>
                  </ul>
                  <p>This Mickey Award comes with a four-leaf clover and a reminder that sometimes you just need your opponent to have their worst week of the season.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="team-analysis">
            <h2 className="section-headline">🏆 Power Rankings (Post-Week 6) with Playoff Probabilities</h2>
            <p><strong>Playoff Structure:</strong> Top 5 records make playoffs + 1 wild card (highest points for outside top 5)</p>
            <p><strong>Historical Context:</strong> 8 wins is typically sufficient to make playoffs</p>

            <div className="power-rankings-section">
              <h3>Tier 1: Playoff Locks</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>1. pranavj20 (5-1, 874 PF) - 99% Playoff Probability</h4>
                  <p>Already at 5 wins with 8 games remaining means they only need 3 more wins to reach the magic 8-win threshold. Even a mediocre 3-5 finish gets them to 8-6, which historically makes the playoffs.</p>
                </div>

                <div className="team-card">
                  <h4>2. swahili28 (4-2, 838 PF) - 95% Playoff Probability</h4>
                  <p>At 4 wins, need just 4 more wins in final 8 games to hit 8-6. With second-highest points for (838), they're on track to cruise into the playoffs comfortably.</p>
                </div>

                <div className="team-card">
                  <h4>3. pranav4789 (3-3, 882 PF) - 92% Playoff Probability</h4>
                  <p>Need 5 more wins in 8 games to reach 8-6, but the HIGHEST points for (882) in league provides wild card insurance. Even at 7-7, their elite scoring virtually locks the 6th seed. Regression to mean suggests record will improve to match scoring anyway.</p>
                </div>
              </div>

              <h3>Tier 2: Bubble Teams</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>4. SahitReddi (4-2, 808 PF) - 90% Playoff Probability</h4>
                  <p>Four wins with 8 games remaining means going 4-4 gets them to the 8-win threshold. Currently riding a hot streak, should easily reach 8 wins for playoff spot.</p>
                </div>

                <div className="team-card">
                  <h4>5. audumula (4-2, 776 PF) - 85% Playoff Probability</h4>
                  <p>Four-game winning streak has them at 4 wins already. Need just 4 more wins in 8 games to reach 8-6 and lock playoffs. Lower points for raises slight concern about sustainability.</p>
                </div>

                <div className="team-card">
                  <h4>6. ankithe (3-3, 813 PF) - 75% Playoff Probability</h4>
                  <p>At 3 wins, need 5 more in final 8 games to reach 8-6. Third-highest points for (813) with CMC's elite production provides solid floor. Should be able to find 5 wins with this talent level.</p>
                </div>

                <div className="team-card">
                  <h4>7. kulkdaddy47 (3-3, 805 PF) - 70% Playoff Probability</h4>
                  <p>Need 5 wins in next 8 to reach 8-6 threshold. Solid points for (805) suggests talent is there, but Week 6's 99-point disaster shows concerning volatility that could derail 5-3 finish needed.</p>
                </div>

                <div className="team-card">
                  <h4>8. abhishekD (3-3, 779 PF) - 65% Playoff Probability</h4>
                  <p>At 3-3, need 5-3 finish to hit 8 wins. The boom-bust pattern makes this risky - one more disaster week and they'd need 5-2 finish. Volatility makes 8 wins harder to reach.</p>
                </div>

                <div className="team-card">
                  <h4>9. taahakm (3-3, 726 PF) - 55% Playoff Probability</h4>
                  <p>Need 5 more wins in 8 games for 8-6 record. Lowest points for among 3-3 teams (726) suggests they've been lucky and puts them as a long shot for the wild card. Getting 5 wins with this low scoring ceiling might be the only path to the playoffs.</p>
                </div>
              </div>

              <h3>Tier 3: Long Shots</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>10. roshik (2-4, 740 PF) - 30% Playoff Probability</h4>
                  <p>At 2-4, need to go 6-2 in final 8 games to reach 8-6 threshold. This is a very difficult path requiring near-perfect execution with limited margin for error.</p>
                </div>

                <div className="team-card">
                  <h4>11. akhilmetukuru (2-4, 725 PF) - 25% Playoff Probability</h4>
                  <p>Need 6 wins in final 8 games to hit 8-6. Second-lowest points for makes this extremely unlikely - would need to overperform expectations significantly while others collapse.</p>
                </div>

                <div className="team-card">
                  <h4>12. abhiu (0-6, 721 PF) - 2% Playoff Probability</h4>
                  <p>Would need to win all 8 remaining games to reach 8-6. Mathematically possible but realistically the season is pretty much over. Even 8-6 might not be enough if multiple teams reach that record.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="season-outlook">
            <h2 className="section-headline">🏅 Early Season GM of the Year Award</h2>
            <div className="award-section">
              <h3>Winner: SahitReddi (Sahit) - The Injury Survivor</h3>
              <p>In a league where one bad draft pick or unlucky injury can derail a season, SahitReddi deserves recognition for navigating a minefield of injuries to reach 4-2 and establish himself as a legitimate championship contender.</p>

              <h4>Injury Adversity:</h4>
              <ul>
                <li><strong>Bucky Irving:</strong> Key RB depth piece hit with injury, forcing roster pivots</li>
                <li><strong>Joe Burrow:</strong> QB1 inconsistency due to injury concerns created weekly uncertainty</li>
                <li><strong>Austin Ekeler:</strong> Veteran RB depth injured, eliminating fallback option</li>
              </ul>

              <h4>Resilience:</h4>
              <ul>
                <li>Started season 0-2 when injuries were piling up and roster looked doomed</li>
                <li>4-0 run (Weeks 3-6) shows incredible dog from the team that usually stems from the fight coach has instilled in his players</li>
              </ul>

              <h4>In-Season Management Excellence:</h4>
              <ul>
                <li>Made correct waiver wire moves to replace injured players – most notably Kendrick Bourne</li>
                <li>Found ways to win even when QB and RB depth was decimated</li>
                <li>Three straight 135+ point performances show roster optimization</li>
              </ul>

              <h4>Honorable Mention:</h4>
              <ul>
                <li><strong>Pranav4789 (Pranav P):</strong> Top scoring team in the league, rookie dominance is impressive</li>
                <li><strong>audumula (Anudeep):</strong> Four-game win streak shows excellent mid-season adjustments</li>
                <li><strong>pranavj20 (Pranav Jain):</strong> 5-1 with league's best record is always GM-worthy</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Week6Newsletter;
